<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <l-data-table
      :get-data-func="getItems"
      :headers="headers"
      @click:row="goDetails('readonly',$event.item)"
      clickable
      init-sort-by="name"
      ref="dataTable"
      selectable
      title-text="角色列表"
      v-model="selected"
      search-text="搜索角色名称"
    >
      <template slot="title-action">
        <l-option-menu
          :options="moreActions"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="deleteItem(item)" icon>
            <v-icon small>$vuetify.icons.delete</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import {time} from '../../../ladmin/utils'

export default {
  name: 'RoleList',
  data: () => ({
    selected: [],
    floatingButton: false,
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    headers: [
      {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A', maxWidth: '14em', tooltip: true},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
  }),
  watch: {
    '$route' (to, from) {
      if (to.name === 'RoleList' && from.name === 'NewRole') {
        this.$refs.dataTable.refresh()
      }
    }
  },
  methods: {
    async getItems ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('userAdmin/getRoles', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
    },
    async deleteItem (item) {
      // console.log(user)
      if (!item) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该角色？',
        text: item.name || `N/A`,
      })
      if (res) {
        try {
          await this.$store.dispatch('userAdmin/deleteRoles', [item])
          this.$L.alert('success', {message: '删除成功'})
          this.$refs.dataTable.refresh()
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
      }
      close()
    },
    goDetails (status, item, force) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        if (status === 'new') {
          this.$router.push({name: 'NewRole'})
        }
        else {
          this.$router.push({
            name: 'RoleDetails',
            params: {shiroStr: item.shiroStr},
            query: {id: item.id}
          })
        }
      }
    },
    goNew () {
      this.$router.push({
        name: 'NewRole'
      })
    }
  }
}
</script>

<style scoped>

</style>
